if(typeof typeSlug == "undefined") {
    var typeSlug = "";
}

if (!Date.now) {
    Date.now = function() { return new Date().getTime(); }
}

//function initializeTextarea(id, locale) {
//    CKEDITOR.editorConfig = function( config ) {
//        config.language = locale;
//        config.height = 300;
//        config.toolbarCanCollapse = true;
//        config.extraPlugins = 'colorbutton';
//        config.colorButton_colors = '00ABE3';
//        config.filebrowserUploadUrl = Routing.generate("ckeditor_upload_path", {
//            "typeSlug": typeSlug
//        });
//    };
//    CKEDITOR.replace(id);
//}

function initializeTextareas() {

    if(typeof type == "undefined") {
        type = null;
    }

    $("textarea.ckeditor").ckeditor({
        customConfig: '/assets/ckeditor-config.js'
    });

    //CKEDITOR.dtd.$removeEmpty['span'] = false;
    CKEDITOR.dtd.$removeEmpty['i'] = false;
}


function initializeTextarea(textarea) {

    $(textarea).ckeditor({
        customConfig: '/assets/ckeditor-config.js'
    });

    //CKEDITOR.dtd.$removeEmpty['span'] = false;
    CKEDITOR.dtd.$removeEmpty['i'] = false;
}


function destroyTextarea(textarea) {

    $(textarea).ckeditor(function(){
        this.destroy();
    });

    //CKEDITOR.dtd.$removeEmpty['span'] = false;
    CKEDITOR.dtd.$removeEmpty['i'] = false;
}

function initializeLimitedTextareas() {

    $("textarea.ckeditor-limited").ckeditor({
        customConfig: '/assets/ckeditor-limited-config.js'
    });

    //CKEDITOR.dtd.$removeEmpty['span'] = false;
    CKEDITOR.dtd.$removeEmpty['i'] = false;
}

function initializeLimitedWithTableTextareas() {

    $("textarea.ckeditor-limited-with-table").ckeditor({
        customConfig: '/assets/ckeditor-limited-with-table-config.js'
    });

    //CKEDITOR.dtd.$removeEmpty['span'] = false;
    CKEDITOR.dtd.$removeEmpty['i'] = false;
}